export default {"src":"/_next/static/media/kolkata.a2ac8230.svg","height":78,"width":132};